angular.module('shared').constant('FeatureFlag', {
  EventCancellations: 'cancelled-events'
});

angular.module('shared').factory('FeatureFlagsService', function() {
  var enabledFeatures;
  enabledFeatures = window.cwxEnabledFeatures || [];
  return {
    enabledFeatures: enabledFeatures,
    isEnabled: function(featureCode) {
      return enabledFeatures.indexOf(featureCode) !== -1;
    }
  };
});
